// Frontend mirror of the backend role permission matrix (auth.py PERMS).
// master_admin implicitly has every permission. The server sends each user's
// effective list (role +/- their individual overrides) — prefer that; this
// matrix is only the fallback for an old token with no list in it.
const M = 'management', T = 'technical_management', R = 'sales_rep',
  P = 'project_coordinator', S = 'sales_support', A = 'accounting', E = 'executive', U = 'us_datasheet_creator';

export const PERMS = {
  'dashboard': [M, R, S, T, E],
  'dashboard.discrepancies': [T],
  'salesintel.overall': [M, A, E],
  'salesintel.forecast': [M, A, P, T, E],
  'salesintel.stale': [M, A, E],
  'salesintel.items': [M, A, P, T, E],
  'salesintel.deep': [M, A, E],
  'salesintel.any': [M, A, P, T, E],
  'search': [M, R, S, T, E],
  'datasheets.view': [M, R, S, T, U],
  'datasheets.corerange': [M, R, S, T, U],
  'datasheets.publish': [M, T, U],
  'datasheets.edit_library': [M, T],
  'datasheets.submit': [S, U],
  'datasheets.personal': [M, R, S, T, U],
  'us.codegen': [M, T, R, S, U],
  'migrate': [T],
  'codegen': [T],
  'aiimport': [T],
  'archive.view': [M, R, S, T],
  'archive.manage': [T],
  'projects.view': [M, T, R, S],
  'projects.all': [M, T],
  'projects.assign': [M, T, R],
  'studio': [M, R, S, T],
  'quotebuilder': [M, T, S, R],
  'quotebuilder.priceupdate': [M, T],
  'costs.view': [M, T, S, R, E],
  'quotes.view': [M, T, S, R, E],
  'quotes.all': [M, E],
  'skus': [T],
  'admin': [M],
};

export const can = (role, perm) =>
  role === 'master_admin' || (PERMS[perm] || []).includes(role);

// Access for a specific person: their server-calculated list when present.
export const canUser = (user, perm) => {
  if (!user) return false;
  if (user.role === 'master_admin') return true;
  if (Array.isArray(user.perms) && user.perms.length) return user.perms.includes(perm);
  return can(user.role, perm);
};

// Human labels + grouping for the per-user access editor.
export const PERM_GROUPS = [
  ['Pages', [
    ['dashboard', 'Dashboard'],
    ['dashboard.discrepancies', 'Dashboard — discrepancy flags'],
    ['search', 'Product Search'],
    ['quotebuilder', 'Quote Builder'],
    ['quotes.view', 'Saved Quotes'],
    ['projects.view', 'Projects'],
    ['studio', 'Proposal Studio'],
    ['admin', 'Admin'],
  ]],
  ['Datasheets', [
    ['datasheets.view', 'Datasheet library (view)'],
    ['datasheets.corerange', 'Core Range page'],
    ['datasheets.personal', 'Personal datasheets'],
    ['datasheets.publish', 'Save into shared libraries'],
    ['datasheets.edit_library', 'Manage library (approve, families)'],
    ['datasheets.submit', 'Submit for approval'],
    ['aiimport', 'AI Import'],
    ['codegen', 'Code Generator (AU)'],
    ['us.codegen', 'Code Generator (US)'],
    ['skus', 'SKUs'],
    ['migrate', 'Migration Workbench'],
    ['archive.view', 'Archive (view)'],
    ['archive.manage', 'Archive (manage)'],
  ]],
  ['Sales Intelligence', [
    ['salesintel.any', 'Sales Intelligence tab'],
    ['salesintel.overall', 'Company-wide figures'],
    ['salesintel.forecast', 'Sales/Quote Forecasts'],
    ['salesintel.items', 'Items & Stock'],
    ['salesintel.stale', 'Stale quotes'],
    ['salesintel.deep', 'Deep Insights'],
  ]],
  ['Commercial', [
    ['costs.view', 'See costs'],
    ['quotes.all', "See everyone's quotes"],
    ['quotebuilder.priceupdate', 'Push prices to NetSuite'],
    ['projects.all', 'See all projects'],
    ['projects.assign', 'Assign people to projects'],
  ]],
];
